import { actions, elements } from '@ecosystem/newron-design-system';
import React, { useContext, useMemo } from 'react';

import './ConsumerSlidesMessage.css';
import { UpsellContext } from '../../state';
import { getBannerMessages } from '../../utils/consumer-srories';

export const ConsumerSlidesMessage = ({
  onClose,
  onShowMore,
  bannerIndex,
  bannerHeader = 'Brand lost shoppers',
  getBannerMessageFn = getBannerMessages,
}: {
  onClose?: () => void;
  onShowMore?: () => void;
  bannerIndex?: number;
  bannerHeader?: string;
  getBannerMessageFn?: (market?: string, bannerIndex?: number) => { number: string; message: string } | undefined;
}): JSX.Element => {
  const {
    state: { market },
  } = useContext(UpsellContext);
  const { Icon } = elements;
  const { Button } = actions;

  const message = useMemo(() => getBannerMessageFn(market, bannerIndex), [getBannerMessageFn, bannerIndex, market]);

  return (
    <div
      className="Root-mfe-upsell-tooltip consumer-slides-message fixed pt-4 pb-6"
      data-test-id="consumer-slides-message"
    >
      <div className="flex justify-end px-4">
        <button
          onClick={() => {
            onClose && onClose();
          }}
          data-test-id="close-info-box"
        >
          <Icon color="brand">
            <Icon.icons.Close />
          </Icon>
        </button>
      </div>
      <div className="relative">
        <div className="px-6 consumer-slides-header">
          <p className="text-lg font-bold">{bannerHeader}</p>
        </div>
        <div className="py-5">
          <p className="text-brand text-4xl font-bold text-center">{message?.number ?? ''}</p>
        </div>
        <div className="px-6">
          <p>{message?.message ?? ''}</p>
        </div>
      </div>
      <div className="flex justify-end mt-6 px-6">
        <Button
          testId="consumer-slides-show-more"
          onClick={() => {
            onShowMore && onShowMore();
          }}
        >
          Tell me more
        </Button>
      </div>
    </div>
  );
};
